import { defineComponent as u, useTemplateRef as d, computed as r, onMounted as c, createElementBlock as v, openBlock as S, mergeProps as w, unref as a, renderSlot as G } from "vue";
import { classesFromBreakpointProps as n } from "../../breakpoints.js";
import { toCamelCase as b } from "../../util.js";
import e from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import { useOUIAProps as y } from "../../helpers/ouia.js";
const L = /* @__PURE__ */ u({
  name: "PfToolbarGroup",
  __name: "ToolbarGroup",
  props: {
    variant: {},
    alignItems: {},
    alignSelf: {},
    overflowContainer: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    visibility: {},
    visibilitySm: {},
    visibilityMd: {},
    visibilityLg: {},
    visibilityXl: {},
    visibility2xl: {},
    align: {},
    alignSm: {},
    alignMd: {},
    alignLg: {},
    alignXl: {},
    align2xl: {},
    gap: {},
    gapSm: {},
    gapMd: {},
    gapLg: {},
    gapXl: {},
    gap2xl: {},
    columnGap: {},
    columnGapSm: {},
    columnGapMd: {},
    columnGapLg: {},
    columnGapXl: {},
    columnGap2xl: {},
    rowGap: {},
    rowGapSm: {},
    rowGapMd: {},
    rowGapLg: {},
    rowGapXl: {},
    rowGap2xl: {},
    rowWrap: {},
    rowWrapSm: {},
    rowWrapMd: {},
    rowWrapLg: {},
    rowWrapXl: {},
    rowWrapXl2: {}
  },
  emits: ["clear-all-filters", "mounted"],
  setup(t, { emit: s }) {
    const o = t, p = y({ id: o.ouiaId, safe: o.ouiaSafe }), m = s, l = d("elRef"), f = r(() => [
      ...n(o, ["visibility", "rowWrap"], e, { short: !0 }),
      ...n(o, ["align", "gap", "columnGap", "rowGap"], e)
    ]), g = r(() => o.variant ? e.modifiers[b(o.variant)] : null);
    return c(() => {
      l.value && m("mounted", l.value);
    }), (i, C) => (S(), v("div", w(a(p), {
      ref: "elRef",
      class: [a(e).toolbarGroup, f.value, g.value, {
        [a(e).modifiers.alignItemsStart]: i.alignItems === "start",
        [a(e).modifiers.alignItemsCenter]: i.alignItems === "center",
        [a(e).modifiers.alignItemsBaseline]: i.alignItems === "baseline",
        [a(e).modifiers.alignSelfStart]: i.alignSelf === "start",
        [a(e).modifiers.alignSelfCenter]: i.alignSelf === "center",
        [a(e).modifiers.alignSelfBaseline]: i.alignSelf === "baseline",
        [a(e).modifiers.overflowContainer]: i.overflowContainer
      }]
    }), [
      G(i.$slots, "default")
    ], 16));
  }
});
export {
  L as default
};
